import React, { useEffect, useState, useRef } from 'react'
import cssLessonAnimation from './LessonAnimation.module.scss'
import CircularProgress from '@material-ui/core/CircularProgress'
import './LessonAnimation.css'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "LessonAnimation"
// #endregion Constant

// #region Member Variables
let mblnInitialized = false
let mstrLUCatSeqNo = ""
let mstrBookCatID = ""
let mstrIframeKey = "" // 用來強制讓iframe更新
// #endregion Member Variables

const ImageTypeEnum = {
    Origin: 1,
    Thumbnail: 2
}

function LessonAnimation(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [showIFrameVideoPlayer, setShowIFrameVideoPlayer] = useState(false)
    const [fullScreenVideoPlayer, setFullScreenVideoPlayer] = useState(false)
    const [initedIFrame, setInitedIFrame] = useState(false)

    const [isPosterLoaded, setIsPosterLoaded] = useState(false)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)
    let mrefMessageReceived = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    mrefMessageReceived.current = MessageReceived
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrIframeKey = GlobalLibs.GenerateUUID()
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        GlobalLibs.AddWindowMessageEvent(mrefMessageReceived.current)
        mrefPaintedMe.current()
        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mblnInitialized = false
            GlobalLibs.RemoveWindowMessageEvent()
            mrefCleanUp.current()
        }
    }, [props.PathName])
    // #endregion useEffect

    function LoadImageProcess()
    {
        console.log(COMP_NAME + ".LoadImageProcess: ")
        
        let objImage = new Image()
        objImage.onload = function ()
        {
            ImageLoadedHandler()
        } // end of image onload
        objImage.src = GetPosterImage(window.gSession.App.BookSeqNo, ImageTypeEnum.Origin)
    }

    function ImageLoadedHandler()
    {
        console.log(COMP_NAME + ".ImageLoadedHandler: ")

        setIsPosterLoaded(true)
    }

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        LoadImageProcess()

        RegisterLanguageChangeHandler()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        UnregisterLanguageChangeHandler()
    }
    // #endregion Painted Me

    // #region OnTapHandler

    // summary: 影片播放到結尾的事件
    function VideoCanPlayEventHandler()
    {
        console.log(COMP_NAME + ".VideoCanPlayEventHandler")
    }

    function VideoEndedEventHandler()
    {
        console.log(COMP_NAME + ".VideoEndedEventHandler")

        setShowIFrameVideoPlayer(false)
        setFullScreenVideoPlayer(false) // 離開全螢幕 視窗縮小回原本的大小
    }

    function VideoEnterFullScreenEventHandler()
    {
        console.log(COMP_NAME + ".VideoEnterFullScreenEventHandler")
        setFullScreenVideoPlayer(true)
    }

    function VideoExitFullScreenEventHandler()
    {
        console.log(COMP_NAME + ".VideoExitFullScreenEventHandler:")
        setFullScreenVideoPlayer(false)
    }

    function PosterOnTapHandler(event)
    {
        console.log(COMP_NAME + ".PosterOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        setShowIFrameVideoPlayer(true)
    }
    // #endregion OnTapHandler

    // #region Other Handler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")

        mstrIframeKey = GlobalLibs.GenerateUUID() // 讓iframe重新Load影片
        setShowIFrameVideoPlayer(false)
        setFullScreenVideoPlayer(false)
    }
    // #endregion Other Handler

    // #region Other Functions
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/15 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler


    // #region Video Player

    // summary: Iframe 讀取完畢
    function IframeOnLoaded(e)
    {
        console.log(COMP_NAME + ".IframeOnLoaded")
        setInitedIFrame(true)
        CallBCVideoPlayerAreYouReady(e.target)
    }

    function GetInitVideoParameters()
    {
        console.log(COMP_NAME + ".GetInitVideoParameters");

        let strVideoUrl = "";
        let strPosterUrl = "";
        let strResourceFN = "";
        // let strPosterFN = "";

        strResourceFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.AnimationFN.Major : props.LUInfo.AnimationFN.Minor;
        console.log("strResourceFN: ", strResourceFN)

        strVideoUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Video, strResourceFN)


        // strVideoUrl = "https://appfsdev.betterchinese.com/original/Lesson_03001/video/01001_animation_major_01.mp4"
        // strVideoUrl = "https://appfsdev.betterchinese.com/original/Lesson_03001/video/01001_animation_major_01_old.mp4"
        // strVideoUrl = "https://appfsdev.betterchinese.com/original/Lesson_03001/video/01001_animation_major_01_new_2.mp4"
        
        // strPosterFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? ("animation_poster_major_" + strBookSeqNo) : ("animation_poster_minor_" + strBookSeqNo);
        // if (!window.gSession.App.InApp || (window.devicePixelRatio < 2))
        // {
        //     strPosterFN += "_min";
        // }
        // strPosterFN += ".png";

        console.log("GetInitVideoParameters: strPosterUrl: ", strPosterUrl);
        console.log("GetInitVideoParameters: strVideoUrl: ", strVideoUrl);
        let objInitParam = {
            "PosterUrl": strPosterUrl,
            "VideoUrl": strVideoUrl
        }

        console.log("GetInitVideoParameters: objInitParam:", objInitParam)
        return objInitParam
    }

    function CallBCVideoPlayerAreYouReady(iFrameRef)
    {
        console.log(COMP_NAME + ".CallBCVideoPlayerAreYouReady: ");

        let objInitParam = GetInitVideoParameters()
        console.log("CallBCVideoPlayerAreYouReady: objInitParam:", objInitParam)

        let objMessage = {
            "Credential": window.gSession.Acc.Credential,
            "Func": "AreYouReady",
            "Args": {
                VideoDef: {
                    "PosterUrl": objInitParam.PosterUrl,
                    "VideoUrl": objInitParam.VideoUrl
                }
            }
        }
        console.log("CallBCVideoPlayerAreYouReady: objMessage:", objMessage)
        let strMessage = JSON.stringify(objMessage)
        console.log("CallBCVideoPlayerAreYouReady: strMessage:", strMessage)

        iFrameRef.contentWindow.postMessage(strMessage, PackageVariablesLibs.SysConfig.AppWebDomain)
    }

    function MessageReceived(Event)
    {
        console.log(COMP_NAME + ".MessageReceived: ", Event)

        // get the origin of event
        let strEventOrigin = Event.origin

        if (
            (strEventOrigin !== PackageVariablesLibs.SysConfig.AppWebDomain) &&
            (strEventOrigin !== "file://")
        )
        {
            // e.g. 從Google Classroom進來的 就不處理
            console.log("Not from my parent, cannot accept")
        }
        else
        {
            console.log("Event.data: ", Event.data)
            console.log("typeof(Event.data): ", typeof (Event.data))

            if (typeof (Event.data) === 'object')
            {
                if (Event.data.source.indexOf('react-devtools') !== -1)
                {
                    return
                }
            }
            if (
                (typeof (Event.data) === 'string') &&
                (Event.data === "")
            )
            {
                return
            }

            let objCallData = JSON.parse(Event.data, true)
            /* 特別注意，
            Prelude的Menu也會trigger message, typeof 會是 function
            Sencha touch 的 DatePicker 也會trigger message, typeof 會是 function
             * 還不知道原因
             */

            console.log("typeof(objCallData): ", typeof (objCallData))

            if (typeof (objCallData) === 'object')
            {
                // note that, Init Hand Shaking 時還沒有DCPCross <- richard: 用top，現階段不需要HandShaking

                console.log("objCallData.Credential: ", objCallData.Credential);
                if (objCallData.Credential !== window.gSession.Acc.Credential)
                {
                    console.log("credential not match")
                    // credential not match
                    // error 不做事
                }
                else
                {
                    console.log("objCallData.Func: ", objCallData.Func);
                    console.log("objCallData: ", objCallData)
                    switch (objCallData.Func)
                    {
                        case "VideoCanPlay":
                            VideoCanPlayEventHandler()
                            break
                        case "VideoEnded":
                            console.log("MessageReceived: VideoEnded")
                            VideoEndedEventHandler();
                            break;
                        case "VideoEnterFullScreen":
                            console.log("MessageReceived: VideoEnterFullScreen")
                            VideoEnterFullScreenEventHandler()
                            break;
                        case "VideoExitFullScreen":
                            console.log("MessageReceived: VideoExitFullScreen")
                            VideoExitFullScreenEventHandler()
                            break;
                        default:
                            break;
                    }
                }

            }
        }
    }
    // #endregion Video Player

    // #endregion Other Functions

    // #region LoadingMask and Alert
    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    // #region Component Callback
    // #endregion Component Callback

    function GetPosterImage(BookSeqNo, ImageType)
    {
        const FUNC_NAME = "GetPosterImage"
        console.log(COMP_NAME + "." + FUNC_NAME + " BookSeqNo:", BookSeqNo)
        console.log(COMP_NAME + "." + FUNC_NAME + " ImageType:", ImageType)

        let strImageUrl = ""
        switch (parseInt(BookSeqNo))
        {
            case 1: // Volume 1
                if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_01.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_01_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl:" + strImageUrl)
                    }
                }
                else
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_01.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 1:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_01_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 1:" + strImageUrl)
                    }
                }
                break;
            case 2: // Volume 2
                if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_02.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 2:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_02_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 2:" + strImageUrl)
                    }
                }
                else
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_02.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 2:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_02_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 2:" + strImageUrl)
                    }
                }
                break;
            case 3: // Volume 3
                if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_03.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 3:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_03_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 3:" + strImageUrl)
                    }
                }
                else
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_03.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 3:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_03_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 3:" + strImageUrl)
                    }
                }
                break;
            case 4: // Volume 4
                if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_04.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 4:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_major_04_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 4:" + strImageUrl)
                    }
                }
                else
                {
                    if(ImageType === ImageTypeEnum.Origin)
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_04.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " origin strImageUrl 4:" + strImageUrl)
                    }
                    else
                    {
                        strImageUrl = PackageVariablesLibs.SysConfig.FileServerURL + "/BookCategory03/image/animation_poster_minor_04_thumbnail.png"
                        console.log(COMP_NAME + "." + FUNC_NAME + " thumbnail strImageUrl 4:" + strImageUrl)
                    }
                }
                break;
            default:
                console.log("GetPosterImage.Error")
                break
        }
        return strImageUrl
    }

    // #region Get ClassName and Style

    function GetStylePosterImageVolume(StateShowIFrameVideoPlayer)
    {
        let objStyle = {}
        if (!StateShowIFrameVideoPlayer)
        {
            let intImageType = (isPosterLoaded) ? ImageTypeEnum.Origin : ImageTypeEnum.Thumbnail
            let strImageUrl = GetPosterImage(window.gSession.App.BookSeqNo, intImageType)
            /*
            let strImageUrl = ""
            switch (parseInt(window.gSession.App.BookSeqNo))
            {
                case 1: // Volume 1
                    // objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume1 : cssLessonAnimation.divMinorPosterImageVolume1
                    if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                    {
                        if(isPosterLoaded)
                        {
                            strImageUrl = "https://appfsdev.betterchinese.com" + "/original/BookCategory03/image/animation_poster_major_01.png"
                        }
                        else
                        {
                            strImageUrl = "https://appfsdev.betterchinese.com" + "/original/BookCategory03/image/animation_poster_major_01_thumbnail.png"
                        }
                    }
                    else
                    {
                        if(isPosterLoaded)
                        {
                            strImageUrl = "https://appfsdev.betterchinese.com" + "/original/BookCategory03/image/animation_poster_minor_01.png"
                        }
                        else
                        {
                            strImageUrl = "https://appfsdev.betterchinese.com" + "/original/BookCategory03/image/animation_poster_minor_01_thumbnail.png"
                        }
                    }
                    break;
                case 2: // Volume 2
                    // objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume2 : cssLessonAnimation.divMinorPosterImageVolume2
                    
                    break;
                case 3: // Volume 3
                    // objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume3 : cssLessonAnimation.divMinorPosterImageVolume3
                    break;
                case 4: // Volume 4
                    // objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume4 : cssLessonAnimation.divMinorPosterImageVolume4
                    break;
                default:
                    // objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume1 : cssLessonAnimation.divMinorPosterImageVolume1
                    break
            }
            */

            objStyle = {
                backgroundImage: 'url(' + strImageUrl + ')'
            }
        }
        
        // console.log("objStyle:", objStyle)
        return objStyle
    }


    function GetClsPosterImageVolume(StateShowIFrameVideoPlayer)
    {
        console.log(COMP_NAME + ".GetClsPosterImageVolume: ")

        let objCls = cssLessonAnimation.divHidePosterImage

        if (!StateShowIFrameVideoPlayer)
        {
            console.log("GetClsPosterImageVolume.window.gSession.App.BookSeqNo: ", window.gSession.App.BookSeqNo)
            objCls = cssLessonAnimation.divMajorPosterImageVolume
            /*
            switch (parseInt(window.gSession.App.BookSeqNo))
            {
                case 1: // Volume 1
                    objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume1 : cssLessonAnimation.divMinorPosterImageVolume1
                    break;
                case 2: // Volume 2
                    objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume2 : cssLessonAnimation.divMinorPosterImageVolume2
                    break;
                case 3: // Volume 3
                    objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume3 : cssLessonAnimation.divMinorPosterImageVolume3
                    break;
                case 4: // Volume 4
                    objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume4 : cssLessonAnimation.divMinorPosterImageVolume4
                    break;
                default:
                    objCls = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? cssLessonAnimation.divMajorPosterImageVolume1 : cssLessonAnimation.divMinorPosterImageVolume1
                    break
            }
            */
        }

        return objCls
    }

    function GetClsPosterImagePlay(StateShowIFrameVideoPlayer)
    {
        let objCls = cssLessonAnimation.divHidePosterImage

        if (!StateShowIFrameVideoPlayer)
        {
            objCls = cssLessonAnimation.divPosterImagePlay
        }

        return objCls
    }

    function GetContentAreaCls(IsFullScreen)
    {
        console.log(COMP_NAME + ".GetContentAreaCls: ", IsFullScreen);

        let objCls = cssLessonAnimation.divContentArea

        if (
            (window.gSession.App.InApp) &&
            (IsFullScreen)
        )
        {
            console.log("GetContentAreaCls: divContentAreaFullScreen")
            objCls = cssLessonAnimation.divContentAreaFullScreen
        }

        return objCls
    }

    function GetSubContentVideoCls(IsFullScreen)
    {
        console.log(COMP_NAME + ".GetSubContentVideoCls: ", IsFullScreen);

        let objCls = cssLessonAnimation.divSubContentVideo

        if (
            (window.gSession.App.InApp) &&
            (IsFullScreen)
        )
        {
            console.log("GetSubContentVideoCls: divSubContentVideoFullScreen")
            objCls = cssLessonAnimation.divSubContentVideoFullScreen
        }

        return objCls
    }

    // #endregion Get ClassName and Style

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Render
    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2")
                if (intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssLessonAnimation.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }

        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea");

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        let strInstruction = ""
        if (
            (typeof (props.LUInfo.Instruction) !== 'undefined') &&
            (props.LUInfo.Instruction !== null) &&
            (props.LUInfo.Instruction !== "")
        )
        {
            strInstruction = props.LUInfo.Instruction;
        }

        return (
            <>
                <div className={cssLessonAnimation.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssLessonAnimation.divTitleSubArea}>
                        <div className={cssLessonAnimation.divLessonIcon}></div>
                        <div className={cssLessonAnimation.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssLessonAnimation.divDividerBar}></div>
                        <div className={cssLessonAnimation.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
                <div className={cssLessonAnimation.divTitleLeftInstructionArea}>{strInstruction}</div>
            </>
        )
    }

    function RenderVideoArea()
    {
        // console.log(COMP_NAME + ".RenderVideoArea")

        // 目前Safari 在使用者點擊Poster圖片後 不會自動播放影片 應該是有方法可以讓他自動Play

        if (!showIFrameVideoPlayer)
        {
            // 一開始進入時 不需顯示 直到使用者點擊Poster 才顯示iframe video player
            return null
        }
        else
        {
            // console.log(COMP_NAME + ".RenderVideoArea")

            let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)
            let strInApp4QueryString = window.Globals.GetQueryString4InApp()
            let strSupportLang = "en-US"
            let strTargetLang = "zh-CN"
            let strQueryString = "Credential=" + window.gSession.Acc.Credential
            let strTargetDomain = window.location.protocol + "//" + window.location.hostname
            let strBackgroundColor = "White" // White or Black

            if (
                (typeof (window.location.port) !== 'undefined') &&
                (window.location.port !== null) &&
                (window.location.port !== "")
            )
            {
                strTargetDomain += ":" + window.location.port
            }

            // console.log("strTargetDomain: ", strTargetDomain)
            // console.log("window.location: ", window.location)
            // console.log("window.gSession.App.Env:", window.gSession.App.Env)
            // console.log("intEnv: ", intEnv)
            // console.log("strInApp4QueryString: ", strInApp4QueryString)

            strTargetDomain = encodeURIComponent(strTargetDomain)
            strQueryString = strQueryString + "&TargetDomain=" + strTargetDomain
            strQueryString = strQueryString + "&Env=" + intEnv.toString()           //"2", window.gSession.App.Env
            strQueryString = strQueryString + strInApp4QueryString
            strQueryString = strQueryString + "&SysType=" + window.gSession.App.SysType.toString()
            strQueryString = strQueryString + "&SupportLang=" + strSupportLang
            strQueryString = strQueryString + "&TargetLang=" + strTargetLang
            strQueryString = strQueryString + "&BackgroundColor=" + strBackgroundColor

            let strVideoPlayerUrl = PackageVariablesLibs.SysConfig.AppWebDomain + "/BCVideoPlayer/?" + strQueryString
            console.log("strVideoPlayerUrl: ", strVideoPlayerUrl)

            console.log("LessonAnimation: OpenLoadingMaskFuncRef")

            return (
                <div className={GetSubContentVideoCls(fullScreenVideoPlayer)}>
                    <iframe
                        key={mstrIframeKey} title="IframeVideoPlayer" onLoad={IframeOnLoaded}
                        className={cssLessonAnimation.iframePlayer}
                        src={strVideoPlayerUrl}
                        // style={GetStylePlayerIframe(StateVideoPlayerWidth, StateVideoPlayerHeight, StateVideoPlayerShow, PropsIsVideoFullScreenMode)} 
                        scrolling="no" allow="autoplay;" allowFullScreen
                    />
                </div>
            )
        }
    }

    function RenderCircularProgressArea()
    {
        // console.log(COMP_NAME + ".RenderCircularProgressArea")

        let objBlock = null
        if (
            showIFrameVideoPlayer &&
            !initedIFrame
        )
        {
            objBlock = (
                <div className={cssLessonAnimation.divCircularProgressArea}>
                    {/* Change color and position of CircularProgress? Ref: https://stackoverflow.com/questions/59709633/change-color-and-position-of-circularprogress */}
                    <CircularProgress />
                </div>
            )
        }
        return objBlock
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            <div className={GetContentAreaCls(fullScreenVideoPlayer)}>
                {RenderVideoArea()}
                {RenderCircularProgressArea()}
                <div className={GetClsPosterImageVolume(showIFrameVideoPlayer)} style={GetStylePosterImageVolume(showIFrameVideoPlayer)} onClick={(event) => PosterOnTapHandler(event)}>
                    <div className={GetClsPosterImagePlay(showIFrameVideoPlayer)}></div>
                </div>
            </div>
        </>
    )
    // #endregion Render
}
export default LessonAnimation